import React, { useState } from "react";
import { saveFormsyRelatedObject, sendEmail } from "../services/soar";
import Input from "../common/Input";

function Comments({ data, refresh }) {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [commentText, setCommentText] = useState("");
  let users = [];
  if (data?.Related) {
    const shared = data.Related.filter(
      (r) => r.ObjectType === "Shared" && r.Active === true
    ).map((r) => r.ObjectJSON.domain);
    users = [
      `${data.PrimaryObjectUser}@safy.org`,
      `${data.SecondaryObjectUser}@safy.org`,
      ...shared,
    ];
  }

  const addComment = () => {
    const comment = [
      {
        Action: "Insert",
        ObjectType: "Comment",
        ObjectJSON: {
          createdBy: safyInfo.user.displayName,
          createdOn: new Date(),
          message: commentText,
        },
      },
    ];
    saveFormsyRelatedObject(data.SubmissionId, comment).then((response) => {
      const link = `${
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "https://safyportal.safy.org"
          : "https://safyportaltest.safy.org"
      }/supervision/${
        data.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
          ? "individual"
          : "group"
      }/${data.SubmissionId}`;
      sendEmail(
        users,
        safyInfo.user.email,
        "A Comment has been added",
        `${safyInfo.user.displayName} has added a comment to a supervision log at <a href="${link}">${link}</a><br/>Comment: ${commentText}`
      );
      setCommentText("");
      refresh();
    });
  };

  return (
    <div className="border rounded my-4 p-2 bg-light">
      <div className="h5">Comment History/Addendums</div>
      <div className="my-4">
        {data?.Related?.filter((r) => r.ObjectType === "Comment").map(
          (c, index) => (
            <div className="m-4" key={`comment${c.ReldatedId}${index}`}>
              <div
                className={`row ${
                  safyInfo.user.azureId.toUpperCase() ===
                    c.CreatedById.toUpperCase() && "justify-content-end"
                }`}
              >
                <div className="col-4 h6">{`${
                  c.ObjectJSON.createdBy
                } - ${new Date(c.ObjectJSON.createdOn).toLocaleString()}`}</div>
              </div>
              <div className="border rounded bg-white p-2">{`${c.ObjectJSON.message}`}</div>
            </div>
          )
        )}
      </div>
      <div className="mb-4 pb-4">
        <Input
          name="addComment"
          label="Add Comment"
          onChange={(e) => setCommentText(e.currentTarget.value)}
          value={commentText}
        ></Input>
      </div>
      <div className="row m-2">
        <div className="col">
          <div
            className="btn btn-success float-end mb-4"
            onClick={() => addComment()}
          >
            Add
          </div>
        </div>
      </div>
    </div>
  );
}

export default Comments;
